module.exports = mapboxgl;